import React, { Component } from 'react';

class getItemsv2 extends Component {

  mostrarItems = () => {
    const items = this.props.items;
    if(items.length === 0) return null;
    //<div  className="css_item">
    const convertJavaColorToCSS = (javaColor) => {
      if (!javaColor) return "#dadada"; // Si el color es null, devuelve negro
      let hexColor = `#${(javaColor & 0xFFFFFF).toString(16).padStart(6, '0')}`;
      return hexColor;
    };
    return (
      <React.Fragment>
        {items.map(item => (
          <span key={item.id_item} className="boton_itemv2"><button className="boton_item_span" style={{backgroundColor:convertJavaColorToCSS(parseInt(item.color))}} onClick={ () => this.props.recuperar_item(item.id_sub_puntoventa_pantalla, item.activo,item.id_item, item.item, item.precio_venta, item.iva, item.servicio, item.w_incluido, item.id_rubro, item.id_subrubro, item.pfinal,item.id_combo,item.carga_maxima
          )}>{item.puntoventa_pantalla}</button></span>
        ) ) }
      </React.Fragment>
    )
  }

  render() {

    let data;
        if (this.props.ok_item===false) {
          data =<div className="div_lbl_loading"><img alt="Cargando Imagen . . ." className="lbl_loading" src={ require('../images/loading.gif') } /></div>
          //console.log(this.props.ok_item);
        } else {
          data = <React.Fragment>
            {this.mostrarItems()}
          </React.Fragment>
        }

    return (
      <React.Fragment>
            {data}
      </React.Fragment>
    );
  }
}
export default getItemsv2;
